import React, { FC } from 'react';

import { Grid, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { FormikProps } from 'formik';

import { ShiftSourceItems } from '@pharmaplan/common';
import strings from '../../../../localization';
import CustomDropdown from '../../../common/CustomDropdown';
import FilterSubmitButtons from '../../../common/FilterSubmitButtons';

import { styles } from '../styles';
import CustomTableBack from '../../../common/CustomTableBack';

interface ICampaignBookingHeader {
  formik: FormikProps<any>;
  handleReset: () => void;
  backToLabel:string;
}

const CampaignBookingHeader: FC<ICampaignBookingHeader> = ({
  formik,
  handleReset,
  backToLabel,
}) =>
  (
    <Box component="form" onSubmit={formik.handleSubmit}>
      <Box sx={styles.headerContainer}>
        <CustomTableBack backLabel={backToLabel} />
        <Typography sx={styles.title}>{strings.viewBookings}</Typography>
      </Box>
      <Grid container lg={6} xs={6} alignItems="center" wrap="nowrap" sx={styles.filterContainer}>
        <Grid item xs={5}>
          <CustomDropdown
            label={strings.postedBy}
            menuItems={ShiftSourceItems}
            formik={formik}
            name="source"
          />
        </Grid>
        <FilterSubmitButtons handleReset={handleReset} />
      </Grid>
    </Box>
  );

export default CampaignBookingHeader;
